import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SystemGlobalsService } from '../../../system-globals.service';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'as-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  @Input() position: string = "static"
  @Input() destination: string;
  @ViewChild('form') formElement;

  showForm: boolean = false;
  input: string;
  success: boolean = false;

  constructor(public globals: SystemGlobalsService, private _http?: HttpClient) { }

  ngOnInit() {

  }

  showFeedbackFrom(){
    this.showForm  = !this.showForm;
    setTimeout(()=>{
      if (this.showForm){
        this.formElement.nativeElement.focus();
      }
    },0);
  }
  sendFeedback(){

    let payload = {

      "to" : this.destination,
      "message" :
        "Issue: " + this.input + " <br> "
        +  "Page: " + window.location.pathname + "<br>"
        +  'userEmail: ' +  this.globals.constants.usersEmail + "<br>"
        +  "LC: " + this.globals.constants.networkName + "<br>"
      +  'userRole: ' +  this.globals.constants.userRole + "<br>"
      + 'userEmail: ' +  this.globals.constants.usersEmail + "<br>"
      +  'user: ' + this.globals.constants.userName,
      "subject" : "Issue Report from " + this.globals.constants.userName
    }

    this._http.post('/networks/emailGeneric', payload).subscribe((result)=>{
      this.success = true;
      this.input = '';
      this.showForm = false;
      setTimeout(()=>{
        this.success = false;

      }, 3000)
    })
  }

}
